import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChargesState {
  shouldRefetch: boolean;
}

const initialState: ChargesState = {
  shouldRefetch: false,
};

const chargesSlice = createSlice({
  name: "charges",
  initialState,
  reducers: {
    triggerRefetch: (state) => {
      state.shouldRefetch = true;
    },
    resetRefetch: (state) => {
      state.shouldRefetch = false;
    },
  },
});

export const { triggerRefetch, resetRefetch } = chargesSlice.actions;

export default chargesSlice.reducer;
